import Swiper from 'swiper/bundle';
import { accessiblePagination, bindPaginationButtons } from '../lib/swiper-pagination.js';
import { updateSlideAccessibility } from '../lib/swiper-a11y.js';
import { onReady } from '../lib/on-ready.js';

function initHeroCarousels() {
    document.querySelectorAll('.swiper-container.swiper-hero-carousel').forEach((container) => {
        if (container.swiper) {
            return;
        }

        new Swiper(container, {
            effect: 'fade',
            loop: false,
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                ...accessiblePagination,
            },
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            fadeEffect: {
                crossFade: true,
            },
            spaceBetween: 30,
            lazy: {
                loadPrevNext: true,
            },
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
                stopOnLastSlide: true,
            },
            on: {
                init(swiper) {
                    bindPaginationButtons(swiper);
                    updateSlideAccessibility(container, swiper);
                },
                slideChange(swiper) {
                    bindPaginationButtons(swiper);
                    updateSlideAccessibility(container, swiper);
                },
                paginationUpdate(swiper) {
                    bindPaginationButtons(swiper);
                },
            },
            a11y: {
                enabled: true,
                slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
            },
        });
    });
}

onReady(initHeroCarousels);
